import * as React from 'react'; // tslint:disable-line

import { classNames } from '../../utils/cn';
var cls = classNames('html');
import sanitizeHtml from 'sanitize-html';
import { unwrapSingleTag } from '../../utils/unwrap-single-tag';
import { reduce } from 'lodash'; // -------- Types -------->

export var HTML_SUP_REPLACEMENTS = {
  '®': '<sup>®</sup>'
};
export var HTMLDefaultProps = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(["h2"]),
  allowedAttributes: sanitizeHtml.defaults.allowedAttributes,
  // @ts-ignore
  allowedIframeHostnames: sanitizeHtml.defaults.allowedIframeHostnames,
  inline: true,
  text: '',
  autoSup: false
}; // -------- Components -------->

export var HTML = function HTML(props) {
  var className = props.className,
      inline = props.inline,
      text = props.text,
      allowedTags = props.allowedTags,
      allowedAttributes = props.allowedAttributes,
      allowedIframeHostnames = props.allowedIframeHostnames,
      unwrap = props.unwrap,
      autoSup = props.autoSup;
  var sanitized = sanitizeHtml(text, {
    allowedTags: allowedTags,
    allowedAttributes: allowedAttributes,
    allowedIframeHostnames: allowedIframeHostnames
  });
  var html = unwrap ? unwrapSingleTag(sanitized, unwrap) : sanitized;
  var Tag = inline ? 'span' : 'div';
  var finalHtml = autoSup ? reduce(HTML_SUP_REPLACEMENTS, function (acc, replaceWith, replace) {
    return acc.replace(new RegExp(replace, 'ig'), replaceWith);
  }, html) : html;
  return React.createElement(Tag, {
    className: cls.name(className),
    dangerouslySetInnerHTML: {
      __html: finalHtml
    }
  });
};
HTML.defaultProps = HTMLDefaultProps;
HTML.cls = cls;